import { queryClient } from '../data/queryClient';

const API = process.env.REACT_APP_BACKEND_URL;

export async function apiFetch(path, options = {}, tentarNovamente = true) {
  const ehForm = options.body instanceof FormData;
  const resp = await fetch(`${API}/api${path}`, {
    credentials: 'include',
    ...options,
    headers: ehForm ? options.headers : { 'Content-Type': 'application/json', ...(options.headers || {}) },
  });
  if (resp.status === 401 && tentarNovamente) {
    const r = await fetch(`${API}/api/auth/refresh`, { method: 'POST', credentials: 'include' });
    if (r.ok) return apiFetch(path, options, false);
  }
  const metodo = (options.method || 'GET').toUpperCase();
  if (resp.ok && metodo !== 'GET' && path.startsWith('/admin/')) {
    queryClient.invalidateQueries();
  }
  return resp;
}

export function erroApi(detail) {
  if (detail == null) return 'Algo deu errado. Tente novamente.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}
